import React                         from 'react';
import { Editor }                    from "react-draft-wysiwyg";
import Grid                          from '@mui/material/Grid';

//import { EditorState, convertToRaw } from "draft-js";
//import draftToHtml                   from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function Wysiwyg (props) {
	const { editorState, handleEditorState } = props;

	//console.log (draftToHtml (convertToRaw(e.getCurrentContent ())));

	return (
		<Grid container spacing={1}>
			<Grid item xs={false} md={1}>
			</Grid>
			<Grid item xs={12} md={10} style={{backgroundColor: '', margin: '20px 20px 20px 20px'}}>
				<Editor
					editorState={editorState}
					toolbarClassName="toolbarClassName"
					wrapperClassName="wrapperClassName"
					editorClassName="editorClassName"
					editorStyle={{border: "1px solid #f1f1f1", height: "500px"}}
					onEditorStateChange={handleEditorState}
				/>
			</Grid>
		</Grid>
	);
}
